import React from "react";

function getCompanyBalance(admin) {
    if(!admin || !admin.length) return false;

    return <span className="money">{`${admin[0].balance_used}/${admin[0].balance_limit}`}</span>
}

export default (props) => {

    const {
        selectedCompany,
        currentAdmin,
        showBalancePopup
    } = props;

    return(
            <div className="my-balance">
                <div className="balance-state">
                    <h3>Баланс компании:</h3>
                    <span className="money">{selectedCompany.balance} р.</span>
                </div>

                {
                    selectedCompany.is_admin ?
                    <div className="balance-state balance-state-limit">
                        <h3>Потрачено/Лимит:</h3>
                        {getCompanyBalance(currentAdmin)}
                    </div>
                    : null
                }

                {
                    selectedCompany.is_admin ?
                    <div className="my-balance-actions">
                        <div className="big-button orange-button-gradient">
                            <button onClick={() => showBalancePopup(selectedCompany)}>Пополнить баланс</button>
                        </div>
                    </div>
                    : null
                }
            </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/Profile/Balance/CompanyBalance.js